
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCautionColorIec as ObiCautionColorIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-caution-color-iec.js';
 
 
 

 
 export const ObiCautionColorIec = createComponent({
   react: React,
   tagName: 'obi-caution-color-iec',
   elementClass: ObiCautionColorIecElement,
   events: {
     
   }
  });
 
 